import React from 'react';

import {
  Card,
  DataTable,
  DataTableColumn,
  DataTableCell
} from '@salesforce/design-system-react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import './AttributeTable.scss';

const CustomDataTableCell = ({ children, property, ...props }) => {
  let val = children;
  if (props.numberStyle) {
    const { formatNumber } = props.intl;
    val = formatNumber(children, props.numberStyle);
  }
  return <td>{val}</td>;
};

CustomDataTableCell.displayName = DataTableCell.displayName;
CustomDataTableCell.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
    PropTypes.array
  ]),
  property: PropTypes.string.isRequired,
  onclick: PropTypes.func,
  onAction: PropTypes.func,
  formatMessage: PropTypes.func,
  item: PropTypes.object,
  numberStyle: PropTypes.object
};

class AttributeTable extends React.Component {
  constructor(props) {
    super(props);
    this.attributeTable = React.createRef();
    this.state = {
      horizontalScroll: false
    };
  }

  columns(attrValue) {
    let cols = [];
    cols = [
      { name: attrValue, sortable: false, width: '100px' },
      { name: 'nrOfAssets', sortable: false, width: '6.25rem' },
      {
        name: 'selections',
        sortable: true,
        numberStyle: { style: 'decimal' },
        width: '6.25rem'
      },
      {
        name: 'ctor',
        sortable: true,
        numberStyle: { style: 'percent', maximumFractionDigits: 2 },
        width: '6.25rem'
      },
      {
        name: 'clicks',
        sortable: false,
        numberStyle: { style: 'decimal' },
        width: '6.25rem'
      }
    ];
    return [...cols];
  }

  headerCell(property, index, formatMessage) {
    if (!index) {
      return formatMessage({
        id: `components.ecs.analytics.assetAttribute.table`
      });
    }
    return formatMessage({
      id: `components.ecs.analytics.assetAttribute.${property}`
    });
  }

  tableData(attrValue) {
    const { formatMessage } = this.props.intl;
    if (this.props.attributes) {
      return this.props.attributes.map(item => {
        if (!item[attrValue]) {
          item[attrValue] = formatMessage({
            id: 'components.ecs.assetFilter.empty'
          });
        }
        return {
          ...item,
          id: (item.dot * Math.random()).toString()
        };
      });
    }
    return [];
  }

  render() {
    const { formatMessage } = this.props.intl;
    const attrValue = Object.keys(this.props.attributes[0])[0];
    const columns = this.columns(attrValue);
    const items = this.tableData(attrValue);
    const selectType = items.length <= this.props.maxSelected ? '' : 'checkbox';
    let selection = this.props.selection;
    if (selection) {
      const selectedKeys = selection.map(s => s[attrValue]);
      selection = items.filter(item => selectedKeys.includes(item[attrValue]));
    }
    return (
      <Card hasNoHeader id="table-wrapper">
        <div className="attribute-table">
          <DataTable
            items={items}
            id="DataTableExample-noRowHover"
            noRowHover
            ref={this.attributeTable}
            onSort={this.handleSort}
            selection={selection}
            selectRows={selectType}
            onRowChange={this.props.onRowSelect}
          >
            {columns.map((col, index) => {
              return (
                <DataTableColumn key={index} sortable={col.sortable}>
                  <CustomDataTableCell
                    property={col.name}
                    formatMessage={formatMessage}
                    label={this.headerCell(col.name, index, formatMessage)}
                    numberStyle={col.numberStyle}
                    intl={this.props.intl}
                    onAction={this.props.onAction}
                  />
                </DataTableColumn>
              );
            })}
          </DataTable>
        </div>
      </Card>
    );
  }
}

AttributeTable.propTypes = {
  maxSelected: PropTypes.number,
  onRowSelect: PropTypes.func,
  selection: PropTypes.array
};

export default injectIntl(AttributeTable);
